var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "holder" }, [
      _c(
        "h2",
        { attrs: { id: "page-header" } },
        [
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("My Arlington")]),
          _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v(" — ")]),
          _c("span", [_vm._v(_vm._s(_vm.metadata.Title))])
        ],
        1
      ),
      _vm._v(" "),
      _vm.ready
        ? _c("div", { attrs: { id: "blurb" } }, [
            _c("div", { domProps: { innerHTML: _vm._s(_vm.markdownToHtml) } }),
            _vm._v(" "),
            _c("br")
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "layer-page" }, [
      _c("div", { staticClass: "widget one-third filter-pane" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isMobile || _vm.mobileMenu === false,
                expression: "isMobile || mobileMenu === false"
              }
            ],
            staticClass: "filter-header",
            attrs: {
              type: "button",
              id: "mobile-menu",
              "aria-expanded": _vm.mobileMenu ? "true" : "false",
              "aria-controls": "filters-and-settings"
            },
            on: {
              click: function($event) {
                _vm.mobileMenu = !_vm.mobileMenu
              }
            }
          },
          [
            _vm._v("\n                Filters and Location\n                "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.mobileMenu,
                    expression: "!mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
            ),
            _vm._v(" "),
            _c(
              "svg",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mobileMenu,
                    expression: "mobileMenu"
                  }
                ],
                staticClass: "icon",
                staticStyle: { float: "right" },
                attrs: { "aria-hidden": "true", focusable: "false" }
              },
              [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isMobile || _vm.mobileMenu,
                expression: "!isMobile || mobileMenu"
              }
            ],
            attrs: { id: "filters-and-settings" }
          },
          [
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMobile,
                      expression: "!isMobile"
                    }
                  ],
                  staticClass: "filter-header",
                  attrs: {
                    type: "button",
                    "aria-expanded": _vm.filtersExpanded ? "true" : "false",
                    "aria-controls": "dynamic-map-filter-list"
                  },
                  on: { click: _vm.filtersToggle }
                },
                [
                  _c("span", [
                    _vm._v("Filters\n                            "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.filtersExpanded,
                            expression: "filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-minus" } })]
                    ),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.filtersExpanded,
                            expression: "!filtersExpanded"
                          }
                        ],
                        staticClass: "icon",
                        staticStyle: { float: "right" },
                        attrs: { "aria-hidden": "true", focusable: "false" }
                      },
                      [_c("use", { attrs: { "xlink:href": "#icon-plus" } })]
                    ),
                    _vm._v(" "),
                    _c("span", {
                      staticStyle: { clear: "both", display: "block" }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.filtersExpanded || _vm.mobileMenu,
                      expression: "filtersExpanded || mobileMenu"
                    }
                  ],
                  staticClass: "filterList",
                  attrs: { id: "dynamic-map-filter-list" }
                },
                [
                  _c("br"),
                  _vm._v(" "),
                  _vm._l(_vm.metadata.FilterCategory, function(
                    category,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c(
                          "div",
                          { staticClass: "filter-item filter-category" },
                          [
                            _vm._v(
                              "\n                          " +
                                _vm._s(category.Label) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(category.Filters, function(filterItem) {
                          return _c(
                            "div",
                            {
                              key: filterItem.Label,
                              staticClass: "filter-item"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "filter-checkbox-label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filterSelected,
                                        expression: "filterSelected"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value:
                                        category.Label +
                                        ":" +
                                        filterItem.Field +
                                        ":" +
                                        filterItem.Value,
                                      checked: Array.isArray(_vm.filterSelected)
                                        ? _vm._i(
                                            _vm.filterSelected,
                                            category.Label +
                                              ":" +
                                              filterItem.Field +
                                              ":" +
                                              filterItem.Value
                                          ) > -1
                                        : _vm.filterSelected
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.filterSelected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v =
                                              category.Label +
                                              ":" +
                                              filterItem.Field +
                                              ":" +
                                              filterItem.Value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.filterSelected = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.filterSelected = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.filterSelected = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "tooltip" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(filterItem.Label) +
                                          "\n                            "
                                      ),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: filterItem.BoxIcon,
                                            expression: "filterItem.BoxIcon"
                                          }
                                        ],
                                        class: "box " + filterItem.BoxIcon
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: filterItem.Tooltip,
                                              expression: "filterItem.Tooltip"
                                            }
                                          ],
                                          staticClass: "tooltiptext"
                                        },
                                        [_vm._v(_vm._s(filterItem.Tooltip))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: filterItem.class,
                                            expression: "filterItem.class"
                                          }
                                        ],
                                        class: filterItem.Icon
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: filterItem.Icon,
                                              expression: "filterItem.Icon"
                                            }
                                          ]
                                        },
                                        [_vm._v(_vm._s(filterItem.Icon))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _vm._l(category.PrecinctFilters, function(filterItem) {
                          return _c(
                            "div",
                            {
                              key: filterItem.Label,
                              staticClass: "filter-item"
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "filter-checkbox-label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.filterSelected,
                                        expression: "filterSelected"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value:
                                        category.Label +
                                        ":" +
                                        filterItem.Field +
                                        ":" +
                                        filterItem.Value,
                                      checked: Array.isArray(_vm.filterSelected)
                                        ? _vm._i(
                                            _vm.filterSelected,
                                            category.Label +
                                              ":" +
                                              filterItem.Field +
                                              ":" +
                                              filterItem.Value
                                          ) > -1
                                        : _vm.filterSelected
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.filterSelected,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v =
                                              category.Label +
                                              ":" +
                                              filterItem.Field +
                                              ":" +
                                              filterItem.Value,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.filterSelected = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.filterSelected = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.filterSelected = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "tooltip" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(filterItem.Label) +
                                          "\n                            "
                                      ),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: filterItem.BoxIcon,
                                            expression: "filterItem.BoxIcon"
                                          }
                                        ],
                                        class: "box " + filterItem.BoxIcon
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: filterItem.Tooltip,
                                              expression: "filterItem.Tooltip"
                                            }
                                          ],
                                          staticClass: "tooltiptext"
                                        },
                                        [_vm._v(_vm._s(filterItem.Tooltip))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: filterItem.class,
                                            expression: "filterItem.class"
                                          }
                                        ],
                                        class: filterItem.Icon
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "v-icon",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: filterItem.Icon,
                                              expression: "filterItem.Icon"
                                            }
                                          ]
                                        },
                                        [_vm._v(_vm._s(filterItem.Icon))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("hr", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.metadata.FilterCategory.length >
                                      index + 1,
                                    expression:
                                      "metadata.FilterCategory.length >index+1"
                                  }
                                ]
                              }),
                              _vm._v(" "),
                              _c("br")
                            ]
                          )
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.metadata.CivicAssociationFilter
              ? _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "civicAssociation" } }, [
                    _vm._v("Civic Association")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.civicAssocationsSelected,
                            expression: "civicAssocationsSelected"
                          }
                        ],
                        attrs: { id: "civicAssociation" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.civicAssocationsSelected = $event.target
                              .multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select a civic association")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.civicAssociations, function(ca) {
                          return _c(
                            "option",
                            { key: ca.OBJECTID, domProps: { value: ca } },
                            [_vm._v(_vm._s(ca.LABEL))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.civicAssociationFailure,
                          expression: "civicAssociationFailure"
                        }
                      ]
                    },
                    [_vm._v("Unable to load Civic Assocations.")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.metadata.VoterPrecinctFilter
              ? _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "voterPrecinct" } }, [
                    _vm._v("Voter Precinct")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.voterPrecinctSelected,
                            expression: "voterPrecinctSelected"
                          }
                        ],
                        attrs: { id: "voterPrecinct" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.voterPrecinctSelected = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Select a voter precinct")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.voterPrecincts, function(ca) {
                          return _c(
                            "option",
                            { key: ca.OBJECTID, domProps: { value: ca } },
                            [_vm._v(_vm._s(ca.POLLING_PLACE))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.voterPrecinctFailure,
                          expression: "voterPrecinctFailure"
                        }
                      ]
                    },
                    [_vm._v("Unable to load Voter Precincts.")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [_vm._v("Zoom to Location")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-container zoom-container" },
              [
                _c("label", { attrs: { for: "addressSearch" } }, [
                  _vm._v("Address")
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("gmap-autocomplete", {
                  ref: "autocomplete",
                  attrs: {
                    id: "addressSearch",
                    placeholder: "Enter street address"
                  },
                  on: { place_changed: _vm.placeChanged }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.metadata.RadiusFilter
              ? _c("div", { staticClass: "filter-container" }, [
                  _c("label", { attrs: { for: "radius" } }, [_vm._v("Radius")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.radiusSelected,
                            expression: "radiusSelected"
                          }
                        ],
                        attrs: {
                          id: "radius",
                          disabled: !_vm.selectedCoordinates
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.radiusSelected = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Set distance")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0.5" } }, [
                          _vm._v("0.5 Mile")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("1 Mile")
                        ])
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c(
                "button",
                {
                  staticClass: "link filter-header",
                  on: { click: _vm.clearAll }
                },
                [_vm._v("Clear All")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.ready
        ? _c(
            "div",
            { staticClass: "widget full-map-pane toggle-window two-thirds" },
            [
              _c("div", { staticStyle: { position: "relative", top: "0" } }, [
                _c(
                  "div",
                  {
                    staticClass: "toggle-bar",
                    attrs: { role: "group", "aria-label": "Map or list" }
                  },
                  [
                    _c(
                      "button",
                      {
                        class:
                          _vm.showMap === true
                            ? "toggle-link"
                            : "toggle-link active",
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.showMap === true
                        },
                        on: {
                          click: function($event) {
                            _vm.showMap = true
                          }
                        }
                      },
                      [_vm._v("Map")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        class:
                          _vm.showMap === false
                            ? "toggle-link"
                            : "toggle-link active",
                        attrs: {
                          type: "button",
                          "aria-pressed": _vm.showMap === false,
                          id: "list-link"
                        },
                        on: {
                          click: function($event) {
                            _vm.showMap = false
                          }
                        }
                      },
                      [_vm._v("List")]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "gmap-map",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMap,
                      expression: "showMap"
                    }
                  ],
                  attrs: {
                    center: _vm.mapCenter,
                    zoom: _vm.zoomLevel,
                    options: _vm.mapStyles,
                    id: "vue-map-container",
                    "aria-label": "Map of locations"
                  }
                },
                [
                  _vm.metadata.Type === "Pins" || _vm.metadata.Type === "Both"
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.filteredItems, function(item) {
                            return _c("gmap-marker", {
                              key: item.location_name,
                              attrs: {
                                position: item,
                                icon: item.icon,
                                options: _vm.shapeOptions
                              },
                              on: {
                                click: function(e) {
                                  return _vm.shapeClick(item, e)
                                }
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "gmap-info-window",
                            {
                              attrs: {
                                opened: _vm.selectedInfoWindowPosition !== null,
                                position: _vm.selectedInfoWindowPosition
                              },
                              on: { closeclick: _vm.infoWindowCloseClick }
                            },
                            [
                              _c("h3", { staticClass: "info-window-header" }, [
                                _vm.selectedItem[_vm.metadata.PinPopupTitle]
                                  ? _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedItem[
                                            _vm.metadata.PinPopupTitle
                                          ]
                                        )
                                      )
                                    ])
                                  : _c("b", [_vm._v("Location")])
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.metadata.PinPopupFields.split(","),
                                function(field, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "info-window" },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            field.indexOf("=") > 0
                                              ? field.split("=")[1].trim()
                                              : field
                                          )
                                        )
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.selectedItem[
                                              field.split("=")[0].trim()
                                            ] || "N/A"
                                          ) +
                                          "\n                      "
                                      )
                                    ]
                                  )
                                }
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCoordinates
                    ? _c("gmap-marker", {
                        attrs: { position: _vm.selectedCoordinates, radius: 24 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCoordinates && _vm.radiusSelected
                    ? _c("GmapCircle", {
                        attrs: {
                          center: _vm.selectedCoordinates,
                          radius: _vm.radiusSelected * 1609,
                          visible: true,
                          options: {
                            fillColor: "blue",
                            fillOpacity: 0.1,
                            strokeWeight: 0.7,
                            strokeColor: "blue"
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.civicAssocationsSelected
                    ? _c("gmap-polygon", {
                        attrs: {
                          path: _vm.civicAssocationsSelected.paths,
                          options: _vm.locationOptions
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.voterPrecinctSelected
                    ? _c("gmap-polygon", {
                        attrs: {
                          path: _vm.voterPrecinctSelected.paths,
                          options: _vm.locationOptions
                        },
                        on: {
                          click: function(e) {
                            return _vm.layerClick(_vm.voterPrecinctSelected, e)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.metadata.Type === "Layers" || _vm.metadata.Type === "Both"
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.filteredItems, function(layer, index) {
                            return _c("gmap-polygon", {
                              key: index,
                              attrs: {
                                path: layer.paths,
                                options: layer.options
                              },
                              on: {
                                click: function(e) {
                                  return _vm.layerClick(layer, e)
                                }
                              }
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "gmap-info-window",
                            {
                              attrs: {
                                opened:
                                  _vm.selectedLayerWindowPosition !== null,
                                position: _vm.selectedLayerWindowPosition
                              },
                              on: { closeclick: _vm.layerWindowCloseClick }
                            },
                            [
                              _c("h3", { staticClass: "info-window-header" }, [
                                _vm.selectedItem[_vm.metadata.LayerPopupTitle]
                                  ? _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.selectedItem[
                                            _vm.metadata.LayerPopupTitle
                                          ]
                                        )
                                      )
                                    ])
                                  : _c("b", [_vm._v("Location")])
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.metadata.LayerPopupFields.split(","),
                                function(field, index) {
                                  return _vm.metadata.LayerPopupFields
                                    ? _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "info-window"
                                        },
                                        [
                                          _c("b", [_vm._v(_vm._s(field))]),
                                          _vm._v(
                                            ": " +
                                              _vm._s(
                                                _vm.selectedItem[
                                                  field.trim()
                                                ] || "N/A"
                                              ) +
                                              "\n                      "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                }
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.showMap,
                      expression: "!showMap"
                    }
                  ],
                  staticClass: "list-pane"
                },
                _vm._l(_vm.filteredItems, function(item, index) {
                  return _c("div", { key: index, staticClass: "project" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("h3", { staticClass: "h3-list" }, [
                          item[_vm.metadata.ListTitle]
                            ? _c("b", [
                                _vm._v(_vm._s(item[_vm.metadata.ListTitle]))
                              ])
                            : _c("b", [_vm._v("Location")])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.metadata.ListFields.split(","), function(
                          field,
                          index
                        ) {
                          return _vm.metadata.ListFields
                            ? _c(
                                "p",
                                {
                                  key: index,
                                  staticClass: "no-vertical-margin"
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        field.indexOf("=") > 0
                                          ? field.split("=")[1].trim()
                                          : field
                                      )
                                    )
                                  ]),
                                  _vm._v(
                                    ": " +
                                      _vm._s(
                                        item[field.split("=")[0].trim()] ||
                                          "N/A"
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ])
                }),
                0
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23a7532c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a7532c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/strapi/map.vue
// module id = GqSA
// module chunks = 1